import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Cookie, X, Settings, Check } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useCookieConsent } from './CookieConsentContext'

export default function CookieBanner() {
  const { showBanner, acceptAll, rejectAll, acceptSelected } = useCookieConsent()
  const [showSettings, setShowSettings] = useState(false)
  const [analytics, setAnalytics] = useState(true)
  const [marketing, setMarketing] = useState(true)

  const handleAcceptSelected = () => {
    acceptSelected({
      necessary: true,
      analytics,
      marketing,
    })
  }

  if (!showBanner) return null

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-0 left-0 right-0 z-50 p-4"
      >
        <div className="container-custom">
          <div className="bg-white rounded-2xl shadow-2xl border border-dark-100 overflow-hidden">
            {!showSettings ? (
              /* Main Banner */
              <div className="p-6 md:p-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Cookie className="w-6 h-6 text-primary" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-display font-bold text-dark-800 mb-2">
                      Questo sito utilizza i cookie
                    </h3>
                    <p className="text-dark-500 mb-4">
                      Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito, 
                      analizzare il traffico e personalizzare i contenuti. Puoi accettare tutti 
                      i cookie o gestire le tue preferenze.{' '}
                      <Link to="/cookie" className="text-primary hover:underline">
                        Leggi la Cookie Policy
                      </Link>
                    </p>
                    <div className="flex flex-wrap gap-3">
                      <button
                        onClick={acceptAll}
                        className="btn-primary text-sm"
                      >
                        Accetta tutti
                      </button>
                      <button
                        onClick={rejectAll}
                        className="btn-outline text-sm"
                      >
                        Rifiuta non necessari
                      </button>
                      <button
                        onClick={() => setShowSettings(true)}
                        className="inline-flex items-center gap-2 px-4 py-2 text-dark-600 hover:text-dark-800 transition-colors text-sm font-medium"
                      >
                        <Settings className="w-4 h-4" />
                        Gestisci preferenze
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              /* Settings Panel */
              <div className="p-6 md:p-8">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-lg font-display font-bold text-dark-800">
                    Gestisci preferenze cookie
                  </h3>
                  <button
                    onClick={() => setShowSettings(false)}
                    className="p-2 hover:bg-dark-100 rounded-full transition-colors"
                  >
                    <X className="w-5 h-5 text-dark-500" />
                  </button>
                </div>

                <div className="space-y-4 mb-6">
                  {/* Necessary Cookies */}
                  <div className="flex items-center justify-between p-4 bg-dark-50 rounded-xl">
                    <div>
                      <h4 className="font-semibold text-dark-800">Cookie necessari</h4>
                      <p className="text-sm text-dark-500">
                        Essenziali per il funzionamento del sito
                      </p>
                    </div>
                    <div className="w-12 h-6 bg-primary rounded-full flex items-center justify-end px-1">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                  </div>

                  {/* Analytics Cookies */}
                  <div className="flex items-center justify-between p-4 bg-dark-50 rounded-xl">
                    <div>
                      <h4 className="font-semibold text-dark-800">Cookie analitici</h4>
                      <p className="text-sm text-dark-500">
                        Ci aiutano a capire come viene utilizzato il sito
                      </p>
                    </div>
                    <button
                      onClick={() => setAnalytics(!analytics)}
                      className={`w-12 h-6 rounded-full flex items-center px-1 transition-colors ${
                        analytics ? 'bg-primary justify-end' : 'bg-dark-300 justify-start'
                      }`}
                    >
                      <div className="w-4 h-4 bg-white rounded-full" />
                    </button>
                  </div>

                  {/* Marketing Cookies */}
                  <div className="flex items-center justify-between p-4 bg-dark-50 rounded-xl">
                    <div>
                      <h4 className="font-semibold text-dark-800">Cookie di marketing</h4>
                      <p className="text-sm text-dark-500">
                        Utilizzati per mostrare annunci pertinenti
                      </p>
                    </div>
                    <button
                      onClick={() => setMarketing(!marketing)}
                      className={`w-12 h-6 rounded-full flex items-center px-1 transition-colors ${
                        marketing ? 'bg-primary justify-end' : 'bg-dark-300 justify-start'
                      }`}
                    >
                      <div className="w-4 h-4 bg-white rounded-full" />
                    </button>
                  </div>
                </div>

                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={handleAcceptSelected}
                    className="btn-primary text-sm"
                  >
                    Salva preferenze
                  </button>
                  <button
                    onClick={acceptAll}
                    className="btn-outline text-sm"
                  >
                    Accetta tutti
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  )
}
